import { Link, Outlet } from "react-router-dom";
import {
  Typography,
  Container,
  TextField,
  Switch,
  InputAdornment,
  InputLabel,
  FormControl,
  OutlinedInput,
  IconButton,
  Box,
  Toolbar,
  AppBar,
  Tabs,
  Tab,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { IoIosArrowRoundBack } from "react-icons/io";
import globe from "../../assets/images/globe.svg";
import globelist from "../../assets/images/globelist.svg";
import yellowadd from "../../assets/images/yellowadd.svg";
import wallet from "../../assets/images/wallet.svg";
import delete1 from "../../assets/images/delete.svg";
import edit from "../../assets/images/edit.svg";
import proifleimg from "../../assets/images/proifleimg.png";
import carpark from "../../assets/images/car-parking.svg";
import tabhome from "../../assets/images/tabhome.svg";
import account from "../../assets/images/account.svg";
import support from "../../assets/images/support.svg";
import applepay from "../../assets/images/applepay.svg";
import { FaCalendarAlt, FaParking, FaCreditCard, FaPencilAlt, FaTrash } from "react-icons/fa";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { BsHouseDoor, BsClockHistory, BsPerson, BsHeadset } from "react-icons/bs";
import { Button, ButtonGroup, Card, Col, Modal, Row } from "react-bootstrap";
import WebService from "../../Services/WebService";
import { toast } from "react-toastify";
import StripeForm from "../../Stripe/StripeForm";
import { loadStripe } from "@stripe/stripe-js";
import { Elements, PaymentElement } from "@stripe/react-stripe-js";

const Account = () => {
  const [show, setShow] = useState(false);
  const [isShowStripeModals, setShowStripeModal] = useState(false);
  const [AccountDetailsData, setAccountDetailsData] = useState<any>(null);
  // const STRIPE_KEY = "";
  // const STRIPE_SECRET = "";
  // const stripePromise = loadStripe(STRIPE_KEY);
  // const [clientSecret, setClientSecret] = useState(STRIPE_SECRET);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    getAccountDetail();
  }, []);

  const getAccountDetail = () => {
    WebService.getAPI({
      action: "/api/Account/Details",
      body: null,
      isShowError: true,
    })
      .then((res: any) => {
        setAccountDetailsData(res);
      })
      .catch((error) => {
        return error;
      });
  };

  const onSubmitPayment = (data: any, type: any) => {
    alert("");
  };

  return (
    <>
      <Container>
        <div className="app-container">
          {/* Sticky Header */}
          <header className="header text-white text-center d-flex justify-content-between align-items-center">
            <div>Account</div>
            <div className=" visablityhidden">
              <button className="back-button">&nbsp;&nbsp;&nbsp;&nbsp;</button>{" "}
            </div>
          </header>
          <Container className="mt-0 px-3 pagewrap">
            {/* Balance Card */}
            <Card className="shadow-sm p-4 mt-3 border-0 account">
              <div className="text-center">
                <img src={wallet} alt="Wallet" width="50" />
                <h5 className="mt-2 current">Current Balance</h5>
                <h2 className="fw-bold amount">${AccountDetailsData?.Balance}</h2>
                <div className="d-flex justify-content-center">
                  <Link to="/addmoney">
                    <Button className="fw-bold text-dark mt-0 btn-light btn-sm addaccount d-flex align-items-center">
                      <img src={yellowadd} alt="Wallet" width="20" /> &nbsp;ADD MONEY
                    </Button>
                  </Link>
                </div>
                <p className="mt-0 text-muted mb-0">
                  Default Add Amount: <strong className="text-dark">${AccountDetailsData?.MinBalance}</strong>{" "}
                  <br />
                </p>
                <p className="mt-2 text-muted">
                  {" "}
                  Minimum Trigger Amount:{" "}
                  <strong className="text-dark">${AccountDetailsData?.MinBalance}</strong>
                </p>
              </div>
            </Card>

            {/* Payment Method Card */}
            <Card className="shadow-sm p-3 mt-3 d-flex flex-row align-items-center justify-content-between border-0">
              <div>
                <span className="text-success">Account Activated</span>
                <p className="fw-bold mb-0">Payment Card Added via Stripe</p>
              </div>
              <div>
                <Button variant="white" className="me-0 p-0">
                  <img src={edit} alt="Wallet" width="20" />
                </Button>
                <Button variant="white">
                  <img src={delete1} alt="Wallet" width="20" />
                </Button>
              </div>
            </Card>

            {/* Add Payment Button */}
            <Button
              className="btn btn-brand-1 w-100 fw-bold w-100 mt-4"
              // onClick={() => setShowStripeModal(true)}
              disabled
            >
              + Add Payment Type
            </Button>
          </Container>
          {/* {isShowStripeModals && clientSecret && (
            // <Modal show={true} centered>
            //   <Modal.Body className="pt-0">
            <div style={{ padding: "15px" }}>
              {/* <Elements stripe={stripePromise} options={{ clientSecret: clientSecret }}>
                    <StripeForm
                      onSubmit={(data: any, type: string) => onSubmitPayment(data, type)}
                      client_secret={clientSecret}
                    />
                  </Elements> */}
              {/* <StripeForm isclose={() => setShowStripeModal(false)} />
            </div>
       </Modal.Body>
           </Modal>
          )}  */}

          {/* Bottom Navigation */}
          <nav className="bottom-nav d-flex justify-content-around align-items-center py-2">
            <div className="nav-item ">
              <Link to="/homepage">
                <img src={tabhome} alt="Parking Spot" className="rounded" style={{ width: "24px" }} />
                <br></br>
                <span>Home</span>
              </Link>
            </div>
            <div className="nav-item ">
              <Link to="/pastpark">
                <img src={carpark} alt="Parking Spot" className="rounded" style={{ width: "24px" }} />
                <br></br>
                <span>Past Parkings</span>
              </Link>
            </div>
            <div className="nav-item active">
              <Link to="/account">
                <img src={account} alt="Parking Spot" className="rounded" style={{ width: "24px" }} />
                <br></br>
                <span>Account</span>
              </Link>
            </div>
            <div className="nav-item">
              <Link to="/supportpage">
                <img src={support} alt="Parking Spot" className="rounded" style={{ width: "24px" }} />
                <br></br>
                <span>Support</span>
              </Link>
            </div>
            <div className="nav-item">
              <Link to="/profile">
                <img src={proifleimg} alt="Profile" className="rounded-circle" />
                <br></br>
                <span>Profile</span>
              </Link>
            </div>
          </nav>

          <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
              <Modal.Title>Sort</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="list-group">
                <label className="d-flex align-items-center mb-3">
                  <input type="radio" name="sort" className="form-check-input me-2" />
                  <span>Newest</span>
                </label>
                <label className="d-flex align-items-center mb-3">
                  <input type="radio" name="sort" className="form-check-input me-2" />
                  <span>Oldest</span>
                </label>
                <label className="d-flex align-items-center mb-3">
                  <input type="radio" name="sort" className="form-check-input me-2" />
                  <span>Less Distance</span>
                </label>
                <label className="d-flex align-items-center">
                  <input type="radio" name="sort" className="form-check-input me-2" />
                  <span>More Distance</span>
                </label>
              </div>
            </Modal.Body>
            <Modal.Footer className="d-flex p-3">
              <Button className="w-50 btn-light">Reset Filter</Button>
              <Button className="w-50 btn-brand-1 font-bold">Apply</Button>
            </Modal.Footer>
          </Modal>
        </div>
      </Container>
    </>
  );
};

export default Account;
